import styled from 'styled-components';
import { Textarea } from 'react-rainbow-components';
import Input from 'components/Input';
import { DIVIDER, GREY_400 } from '../../constants';

export const FieldsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    align-items: stretch;
    gap: 1rem;
    padding: 1rem 0 1rem;

    & > div {
        flex: 1;
    }
`;

export const StyledInput = styled(Input)`
    flex: 1;
    label {
        margin-left: 0;
        font-size: 0.8125rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    input {
        border-radius: 0.375rem;
        border: 1px solid ${DIVIDER};

        ::placeholder {
            font-weight: 300 !important;
        }
    }

    label + div > span {
        color: ${GREY_400};
        width: 1.5rem;
        flex-shrink: 0;
        
        svg {
            width: 1.5rem !important;
            height: 1.5rem !important;
            font-size: 1.5rem !important;
        }        
    }

    div[id^="error-message"] {
        align-self: flex-start;
    }
`;

export const StyledTextarea = styled(Textarea)`
    label {
        margin-left: 0;
        font-size: 0.8125rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    > div {
        border: none;
        box-shadow: none;
    }

    textarea {
        border-radius: 0.375rem;
        border: 1px solid ${DIVIDER};

        :focus, :active {
            border: 2px solid ${DIVIDER};
        }

        ::placeholder {
            font-weight: 300 !important;
        }
    }
`;
